// core version + navigation, pagination modules:
import Swiper from 'swiper';
import {Autoplay, Navigation, Pagination, Scrollbar, Keyboard, A11y} from 'swiper/modules';
import {connect} from "../../../JavaScript/Utils";

class CustomSwiper {
  /**
   *
   * @param element {HTMLElement}
   */
  constructor(element) {

    let params = {
      enabled: true,
      watchOverflow: true,
      modules: [Keyboard, A11y, Autoplay],
      autoplay: {
        enabled: false,
      }
    }

    let withNavigation = Boolean(element.dataset['swiperNavigation']);
    if (withNavigation) {
      params.navigation = {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      }
      params.modules = [...params.modules, Navigation]
    }
    let withPagination = Boolean(element.dataset['swiperPagination']);
    if (withPagination) {
      params.pagination = {
        el: '.swiper-pagination',
        clickable: true,
      }
      params.modules = [...params.modules, Pagination]
    }
    let withScrollbar = Boolean(element.dataset['swiperScrollbar']);
    if (withScrollbar) {
      params.scrollbar = {
        el: '.swiper-scrollbar',
      }
      params.modules = [...params.modules, Scrollbar]
    }
    let swiperMobileSlidesPerView = element.dataset['swiperMobileSlidesPerView'];
    let swiperMobileSpaceBetween = element.dataset['swiperMobileSpaceBetween'];

    params.slidesPerView = swiperMobileSlidesPerView ?? 1;
    params.spaceBetween = swiperMobileSpaceBetween ?? 10;

    let swiperSlidesPerView = element.dataset['swiperSlidesPerView'];
    let swiperSpaceBetween = element.dataset['swiperSpaceBetween'];

    params.breakpoints = {
      992: {
        slidesPerView: swiperSlidesPerView,
        spaceBetween: swiperSpaceBetween,
      }
    }

    let swiperAutoplayDelay = element.dataset['swiperAutoplayDelay'];
    if (swiperAutoplayDelay) {
      params.breakpoints[992].autoplay = {
        enabled: true,
        delay: Number.parseInt(swiperAutoplayDelay),
        pauseOnMouseEnter: true,
      }
    }
    this.instance = new Swiper(element, params);
    // console.log(this);
  }
}

connect('.profinet-slider', CustomSwiper)
